import React, { useEffect } from 'react';

import { resetAllSteps } from 'prequalificationV2/actions/stages';
import { useAppDispatch } from 'prequalificationV2/hooks/useAppDispatch';
import styles from 'prequalificationV2/pages/Error/Error.module.scss';
import FormHeader from 'prequalificationV2/components/FormHeader';
import ErrorIcon from 'components/Icons/ErrorIcon';

const Error = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetAllSteps());
    };
  });

  return (
    <>
      <FormHeader>
        <div className={styles.headerContainer}>
          <h1 className={styles.title}>Oops. An error has occurred.</h1>
          <ErrorIcon className={styles.errorIcon} />
        </div>
      </FormHeader>
    </>
  );
};

export default Error;
